import { useSelector } from "react-redux";
import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import { isNodeStatusPositionedAndHidden } from "../../../abstract/redux/slice/statusSlice";
import styles from "./ParameterContainer.module.scss";
import { useEffect, useRef } from "react";
import { getIsHighlighted } from "../../../abstract/redux/slice/overlaySlice";

function ParameterContainer({ node, children, isFolded }) {
  const _id = nodeUtils.getID(node);

  const _isHighlighted = useSelector(getIsHighlighted(_id));
  const _isPositionedAndHidden = useSelector(isNodeStatusPositionedAndHidden(_id));

  const _ref = useRef(null);

  useEffect(() => {
    if (_isHighlighted) {
      _ref.current?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [_isHighlighted]);

  const getClass = () => {
    if (_isPositionedAndHidden) {
      return `${styles["container-hidden"]}`;
    }

    if (isFolded) {
      return `${styles["container-folded"]}`;
    } else {
      return `${styles["container-default"]}`;
    }
  };

  return (
    <div className={styles["container"]} ref={_ref}>
      <div className={getClass()}>{children}</div>
    </div>
  );
}

export default ParameterContainer;
